module.exports = __webpack_public_path__ + "static/media/crop2.2e80b866.png";